export enum Color {
  PRIMARY = 'primary',
  PRIMARY_DARK = 'primaryDark',
  PRIMARY_LIGHT = 'primaryLight',
  PRIMARY_TRANSPARENT = 'primaryTransparent',

  POSITIVE = 'positive',
  POSITIVE_DARK = 'positiveDark',
  POSITIVE_LIGHT = 'positiveLight',
  POSITIVE_TRANSPARENT = 'positiveTransparent',
  POSITIVE_STATE = 'positiveState',

  WARNING = 'warning',
  WARNING_DARK = 'warningDark',
  WARNING_LIGHT = 'warningLight',
  WARNING_TRANSPARENT = 'warningTransparent',
  WARNING_STATE = 'warningState',

  NEGATIVE = 'negative',
  NEGATIVE_DARK = 'negativeDark',
  NEGATIVE_LIGHT = 'negativeLight',
  NEGATIVE_TRANSPARENT = 'negativeTransparent',
  NEGATIVE_STATE = 'negativeState',

  INFO = 'info',
  INFO_DARK = 'infoDark',
  INFO_LIGHT = 'infoLight',
  INFO_TRANSPARENT = 'infoTransparent',
  INFO_STATE = 'infoState',

  BLACK = 'black',

  WHITE = 'white',
  WHITE_TRANSPARENT = 'whiteTransparent',

  GREY_50 = 'grey50',
  GREY_100 = 'grey100',
  GREY_200 = 'grey200',
  GREY_300 = 'grey300',
  GREY_400 = 'grey400',
  GREY_500 = 'grey500',
  GREY_600 = 'grey600',

  AI = 'ai',
  AI_DARK = 'aiDark',
  AI_LIGHT = 'aiLight',
  AI_TRANSPARENT = 'aiTransparent',

  RES_OPTION = 'resOption',
  RES_CONFIRMED = 'resConfirmed',
  RES_CHECKED_IN = 'resCheckedIn',
  RES_CHECKED_OUT = 'resCheckedOut',
  RES_OTHER = 'resOther',
  RES_CANCELED = 'resCanceled',
  RES_WAITING_LIST = 'resWaitingList',
  RES_NO_SHOW = 'resNoShow',

  PAY_UNPAID = 'payUnpaid',
  PAY_PARTIALLY = 'payPartially',
  PAY_PAID = 'payPaid',

  NOTE = 'note',
  NOTE_DARK = 'noteDark',

  TRANSPARENT = 'transparent',
}
